// eslint-disable-next-line no-restricted-imports
import {reportError} from '@github-ui/failbot'
import {sendEvent} from '@github-ui/hydro-analytics'

export type IssueStatusesUsageContext = {
  surface: 'issue_status_actions'
  cause: 'explicit_selection' | 'close_reopen'
  action: 'select' | 'close' | 'reopen'
  requestComparison: 'same' | 'different' | 'unknown'
}

type ComposerUsageEvent = IssueStatusesUsageContext &
  ({phase: 'submitted'; status?: never} | {phase: 'settled'; status: 'success' | 'error'})

type HeaderUsageEvent = Omit<IssueStatusesUsageContext, 'surface' | 'cause' | 'action'> & {
  surface: 'issue_header' | 'issue_header_sticky'
  cause: 'explicit_selection'
  action: 'select'
} & ({phase: 'submitted' | 'cancelled'; status?: never} | {phase: 'settled'; status: 'success' | 'error'})

type BoardUsageEvent = {
  surface: 'issues_board'
  cause: 'explicit_selection'
  action: 'select'
  requestComparison: 'different' | 'unknown'
} & ({phase: 'submitted'; status?: never} | {phase: 'settled'; status: 'success' | 'error'})

export type IssueStatusCreationProvenance = 'explicit' | 'default' | 'restored' | 'unknown'

type CreationUsageEvent = {
  surface: 'issue_create_full_page' | 'issue_create_modal'
  cause: 'issue_creation'
  action: 'create'
  provenance: IssueStatusCreationProvenance
} & ({phase: 'submitted'; status?: never} | {phase: 'settled'; status: 'success' | 'error'})

export type IssueStatusesUsageEvent = ComposerUsageEvent | HeaderUsageEvent | CreationUsageEvent | BoardUsageEvent

// Provisional client schema. Success acknowledges the request, not a committed transition.
export function reportIssueStatusesUsage(event: IssueStatusesUsageEvent) {
  try {
    sendEvent('issue_statuses_usage', {
      version: '1.0.0',
      source: 'web',
      actor_type: 'unknown',
      surface: event.surface,
      cause: event.cause,
      action: event.action,
      phase: event.phase,
      ...(event.phase === 'settled' ? {status: event.status} : {}),
      ...(event.cause === 'issue_creation'
        ? {selection_provenance: event.provenance}
        : {request_comparison: event.requestComparison}),
    })
  } catch (error) {
    // Analytics must not prevent submission or replace the primary operation's outcome.
    reportError(error)
  }
}
